import Lara from "@/presets/lara";

export const anonymousAdvisingTablePresets = {
  ...Lara,
  datatable: {
    ...Lara.datatable,
    thead: (args) => ({
      class: [...Lara.datatable.thead(args).class],
    }),
  },
};

export const ratingPt = {
  onIcon: { class: "text-yellow-100 text-base" },
  offIcon: { class: "text-gray-300 text-base" },
};

export const viewDetailButtonPt = {
  root: { class: "text-xs text-blue-600 hover:underline p-0 bg-transparent border-0" },
};
